export default {
    methods: {
        showAvailableShift(applicant) {
            const hasNightAvailability = applicant.availability && applicant.availability.night && applicant.availability.night.length > 0 ;
            const hasAfternoonAvailability = applicant.availability && applicant.availability.afternoon && applicant.availability.afternoon.length > 0;
            const hasMorningAvailability = applicant.availability && applicant.availability.morning && applicant.availability.morning.length > 0;

            if (hasNightAvailability && hasAfternoonAvailability && hasMorningAvailability) {
                return '1st & 2nd & 3rd';
            } else if (hasNightAvailability && hasAfternoonAvailability) {
                return '2nd & 3rd';
            } else if (hasNightAvailability && hasMorningAvailability) {
                return '1st & 3rd ';
            } else if (hasAfternoonAvailability && hasMorningAvailability) {
                return '1st & 2nd';
            } else if (hasNightAvailability) {
                return '3rd';
            } else if (hasAfternoonAvailability) {
                return '2nd';
            } else if (hasMorningAvailability) {
                return '1st';
            } else {
                return 'No Availability';
            }
        },
    }
}
